import $ from "jquery";
import moment from "moment";

function getGlobal() {
  window.linksoft = window.linksoft || {};
  return window.linksoft;
}

function asArray(value) {
  return Array.isArray(value) ? value : [value];
}

function resolveResource(namespace) {
  return window.Resx && window.Resx[namespace] ? window.Resx[namespace] : {};
}

export function localize(...namespaces) {
  return namespaces.reduce((result, namespace) => {
    result[namespace] = resolveResource(namespace);
    return result;
  }, {});
}

export function getCurrentLocale() {
  const culture = window.abp?.localization?.currentCulture;
  return culture?.name || culture?.displayName || moment.locale() || document.documentElement.lang || "cs";
}

export function loadLocale() {
  moment.locale(getCurrentLocale().substring(0, 2));
  return Promise.resolve(getCurrentLocale());
}

export const event = {
  on(name, handler) {
    $(document).on(name, (_event, params) => handler(params));
  },
  off(name, handler) {
    $(document).off(name, handler);
  },
  trigger(name, params) {
    $(document).trigger(name, params);
  }
};

export function ajax(options) {
  return $.ajax(options);
}

export const notify = {
  success(message) {
    if (window.abp?.notify?.success) {
      window.abp.notify.success(message);
      return;
    }
    if (window.toastr?.success) {
      window.toastr.success(message);
    }
  },
  error(message) {
    if (window.abp?.notify?.error) {
      window.abp.notify.error(message);
      return;
    }
    if (window.toastr?.error) {
      window.toastr.error(message);
    }
  },
  info(message) {
    if (window.abp?.notify?.info) {
      window.abp.notify.info(message);
      return;
    }
    if (window.toastr?.info) {
      window.toastr.info(message);
    }
  },
  warn(message) {
    if (window.abp?.notify?.warn) {
      window.abp.notify.warn(message);
      return;
    }
    if (window.toastr?.warning) {
      window.toastr.warning(message);
    }
  }
};

function runInitializers(initializers, element) {
  asArray(initializers)
    .filter((initializer) => typeof initializer === "function")
    .forEach((initializer) => initializer(element));
}

const normalInitializers = [];
const finalInitializers = [];

export const initialize = {
  register(initializers, finalizer) {
    (finalizer ? finalInitializers : normalInitializers).push(...asArray(initializers));
  },
  trigger(element) {
    runInitializers(normalInitializers, element || document);
    runInitializers(finalInitializers, element || document);
  }
};

export const store = {
  value: null,
  set(value) {
    this.value = value;
    getGlobal().store = value;
  },
  get() {
    return this.value;
  }
};

export const reducers = {
  items: {},
  add(name, reducer) {
    this.items[name] = reducer;
  },
  get() {
    return this.items;
  }
};

function initAjax(root) {
  const scope = root ? $(root) : $(document);
  scope.find("[data-ajax='true']").addBack("[data-ajax='true']").off("click.linksoftAjax").on("click.linksoftAjax", function (eventObject) {
    eventObject.preventDefault();
    const element = $(this);
    $.ajax({
      url: element.data("ajax-url") || element.attr("href"),
      method: element.data("ajax-method") || "GET"
    }).done(() => {
      const success = element.data("ajax-success");
      if (success) {
        Function(success).call(this);
      }
    }).fail((xhr) => {
      const message = xhr?.responseJSON?.error?.message || xhr?.responseText || "Akci se nepodařilo provést.";
      if (window.abp?.notify?.error) {
        window.abp.notify.error(message);
      } else {
        window.alert(message);
      }
    });
  });
}

function initConfirm(root) {
  const scope = root ? $(root) : $(document);
  scope.find("[data-confirm]").addBack("[data-confirm]").off("click.linksoftConfirm").on("click.linksoftConfirm", function (eventObject) {
    const message = $(this).data("confirm");
    if (message && !window.confirm(message)) {
      eventObject.preventDefault();
      eventObject.stopImmediatePropagation();
      return false;
    }
    return true;
  });
}

function initDatepicker(root) {
  const scope = root ? $(root) : $(document);
  scope.find("[data-provider='datepicker']").each(function () {
    if ($.fn.datetimepicker && !$(this).data("DateTimePicker")) {
      $(this).datetimepicker({ locale: getCurrentLocale().substring(0, 2), format: "L" });
    }
  });
}

function initTooltip(root) {
  const scope = root ? $(root) : $(document);
  if ($.fn.tooltip) {
    scope.find("[data-toggle='tooltip'],[title]").tooltip({ container: "body" });
  }
}

function initClickOnEnter(root) {
  const scope = root ? $(root) : $(document);
  scope.find("[data-click-on-enter]").off("keydown.linksoftClickOnEnter").on("keydown.linksoftClickOnEnter", function (eventObject) {
    if (eventObject.key === "Enter") {
      $($(this).data("click-on-enter")).trigger("click");
    }
  });
}

export const initializers = {
  ajax: initAjax,
  tooltip: initTooltip,
  confirm: initConfirm,
  datepicker: initDatepicker,
  autoQuery: () => {},
  dispatchAction: () => {},
  notify: () => {},
  clickOnEnter: initClickOnEnter
};

const api = {
  ajax,
  event,
  getCurrentLocale,
  initialize,
  initializers,
  loadLocale,
  localize,
  notify,
  reducers,
  store
};

Object.assign(getGlobal(), api);

export default api;
